<template>
  <div
    v-if="queueType === 'последовательное'"
    class="ba-absolute ba-left-1/2 ba-bottom-full ba-h-3 ba-w-px ba-mb-5 ba-bg-current ba-rounded-full ba-transform ba--translate-x-1/2 ba-select-none"
    :class="color"
  />
  <div
    v-else
    :class="color"
  >
    <div
      v-if="isFirst"
      class="ba-absolute ba-right-full ba-inset-y-0 ba-w-7 ba-h-24 ba-mr-5 ba--mt-15 ba-border-l ba-border-b ba-border-current ba-rounded-bl-2xl"
    />
    <div
      v-if="!isLast"
      class="ba-absolute ba-right-full ba-top-0 ba-w-7 ba-h-full ba-mr-5 ba-mt-18 ba-border-l ba-border-b ba-border-current ba-rounded-bl-2xl"
    >
      <div class="ba-absolute ba--left-px ba-bottom-full ba-h-15 ba-border-l ba-border-current" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'vis-approval-queue-task-connection-line',
  props: {
    queueType: {
      type: String,
      default: null
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  }
}
</script>
